import APIs from '../common/APIs'
import defaultRestApi, { defautRequestConfig } from '../common/RestApiInstance'
import querystring from 'query-string'
import isNil from 'lodash/isNil'
import cookie from "react-cookies";
import axios from 'axios';

const strictUriEncode = require('strict-uri-encode');

const encode = (value, options) => {
	if (options.encode) {
		return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

const encoderForArrayFormat = (options) => {
  switch (options.arrayFormat) {
    case 'index':
      return key => (result, value) => {
        const index = result.length;
        if (value === undefined) {
          return result;
        }

        if (value === null) {
          return [...result, [encode(key, options), '[', index, ']'].join('')];
        }

        return [
          ...result,
          [encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join('')
        ];
      };

    case 'bracket':
      return key => (result, value) => {
        if (value === undefined) {
          return result;
        }

        if (value === null) {
          return [...result, [encode(key, options), '[]'].join('')];
        }

        return [...result, [encode(key, options), '[]=', encode(value, options)].join('')];
      };

    case 'comma':
      return key => (result, value, index) => {
        if (!value) {
          return result;
        }

        if (index === 0) {
          return [[encode(key, options), '=', encode(value, options)].join('')];
        }

        return [[result, encode(value, options)].join(',')];
      };

    default:
      return key => (result, value) => {
        if (value === undefined) {
          return result;
        }

        if (value === null) {
          return [...result, encode(key, options)];
        }

        return [...result, [encode(key, options), '=', encode(value, options)].join('')];
      };
  }
}

const stringify = (object, options) => {
  if (!object) {
    return '';
  }

  options = Object.assign({
    encode: true,
    strict: true,
    arrayFormat: 'none'
  }, options);

  const formatter = encoderForArrayFormat(options);
  const keys = Object.keys(object);

  if (options.sort !== false) {
    keys.sort(options.sort);
  }

  return keys.map(key => {
    const value = object[key];

    if (value === undefined) {
      return '';
    }

    if (value === null) {
      return encode(key, options);
    }

    if (Array.isArray(value)) {
      return value
        .reduce(formatter(key), [])
        .join('&');
    }

    return encode(key, options) + '=' + encode(value, options);
  }).filter(x => x.length > 0).join('&');
};

export default class MemberServices {

    static getAnnouncementAPI = () => {
        return defaultRestApi.get(APIs.announcementURL())
    }

  static postLoginAPI = (loginId, password, captcha = '', captchaToken = '') => {
    const data = JSON.parse(localStorage.getItem('trustCode') || '{}');
    const trustCodeStore = data[loginId]
    const trustCodeCookie = cookie.load('trustCode');
    return defaultRestApi.post(APIs.memberLoginURL(),
      querystring.stringify({
        loginId: loginId, //gave the values directly for testing
        password: password,
        captcha: captcha,
        captchaToken: captchaToken
      }), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Trust-Code": trustCodeStore || trustCodeCookie || ''
      }
    })
  }

    static postLogoutAPI = () => {
        return defaultRestApi.post(APIs.memberLogoutURL(), {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
    }

    static getDataNoCacheAPI = () => {
        return defaultRestApi.get(APIs.dataNoCache(), {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
    }

    static postAccountBalanceAPI = () => {
        return defaultRestApi.post(APIs.accountBalanceURL(), null, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "X-Requested-With": "XMLHttpRequest"
            }
        })
    }
    
  static postSumAnnoucementUnreadAPI = () => {
    return defaultRestApi.post(APIs.getSumAnnouncementUnreadURL(), null, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    })
  }

    static getPreferencesAPI = () => {
        return defaultRestApi.get(APIs.preferencesURL(), null, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "X-Requested-With": "XMLHttpRequest"
            }
        })
    }

    static postPreferencesAPI = (params) => {
        return defaultRestApi.post(APIs.preferencesURL(), params)
    }
    
    static getListTimeZonesAPI = () => {
      return defaultRestApi.get(APIs.listTimeZonesURL(), null, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-Requested-With": "XMLHttpRequest"
        }
      })
    }
    
    static getSportsSortingAPI = (country) => {
      return defaultRestApi.get(APIs.sportsSortingURL(country), null, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-Requested-With": "XMLHttpRequest"
        }
      })
    }
    
    static postSportsSorting = (params) => {
      return defaultRestApi.post(APIs.postSportsSortingURL(), querystring.stringify(params))
    }

    /**
     * Call fetching forecasts API
     */
    static getForecastAPI = (forecastParameters) => {
        return defaultRestApi.get(APIs.getForecastURL(forecastParameters),
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
    }

    /**
     * Call fetching multi forecasts API
     */
    static getMultiForecastAPI = (forecastParameters) => {
        return defaultRestApi.post(APIs.getMultiForecastURL(),
            forecastParameters,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
    }

    static getTeaserTicketAPI = (teaserParameters) => {
        return defaultRestApi.get(APIs.getTeaserTicketURL(teaserParameters));
    }

    static removeTeaserTicketAPI = (teaserParameters) => {
        return defaultRestApi.get(APIs.removeTeaserTicketURL(teaserParameters));
    }

    static getMyBetsAPI = () => {
        return defaultRestApi.get(APIs.getMyBetsURL(), {
            headers: {
                "Content-Type": "application/json"
            }
        });
    }
    static getDeleteWagerAPI = (wagerId) => {
        return defaultRestApi.get(APIs.getDeleteMyBetsWager(wagerId),
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
    }

    /**
     * Call updating freshchat id API
     * parameters: [{name: 'freshId', value: restoreId}]
     */
    static updateFreshId = (parameters) => {
        return defaultRestApi.post(APIs.updateFreshIdURL(),
            parameters,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
    }

    static reportSystemError = (errorObject) => {
        return defaultRestApi.post(APIs.reportSystemErrorURL(),
            errorObject,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
    }

  static getAcceptTC = (promoEmail, version) => {
    return defaultRestApi.get(APIs.acceptTCURL(promoEmail, version),
            {
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest"
                }
            }
        );
    }

  static getVersionTNC = (linkTNC) => {
    return defaultRestApi.get(linkTNC,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest"
          }
        }
    );
  }

  static acceptNewMobileBetslip = () => {
    return defaultRestApi.get(APIs.acceptNewMobileBetslip(),
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
  }

  static closeMorebetTooltip = () => {
    return defaultRestApi.post(APIs.closeMorebetTooltip(),
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
  }

    static getCountryAndCurrency = () => {
        return defaultRestApi.get(APIs.memberGetCountryAndCurrency(), {
            headers: {
                "Content-Type": "application/json"
            }
        });
    }

    static postDoForgotUsername = (captcha, captchaToken, email) => {
        return defaultRestApi.post(APIs.memberDoForgotUsername(),
            JSON.stringify({
                captcha: captcha, //gave the values directly for testing
                captchaToken: captchaToken,
                email: email
            }), {
                headers: {
                    'Accept': '*/*',
                    "Content-Type": "application/json; charset=utf-8",
                    "X-Requested-With": "XMLHttpRequest"
                }
            }
        )
    }

    static postDoForgotEmail = (data) => {
        return defaultRestApi.post(APIs.memberDoForgotEmail(),
            data, {
                headers: {
                    'Accept': '*/*',
                    "Content-Type": "application/json; charset=utf-8",
                    "X-Requested-With": "XMLHttpRequest"
                }
            }
        )
    }

    static postDoForgotPassword = (data) => {
        return defaultRestApi.post(APIs.memberDoForgotPassword(),
            data, {
                headers: {
                    'Accept': '*/*',
                    "Content-Type": "application/json; charset=utf-8",
                    "X-Requested-With": "XMLHttpRequest"
                }
            }
        )
    }

    static postCheckLoginId = (loginId) => {
        return defaultRestApi.post(APIs.memberCheckLoginId(),
            querystring.stringify({
                loginId: loginId
            }), {
                headers: {
                    'Accept': '*/*',
                    "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
                    "X-Requested-With": "XMLHttpRequest"
                }
            }
        )
    }

    static postDoSignUp = (data) => {
        return defaultRestApi.post(APIs.memberDoSignUp(),
            JSON.stringify(data), {
                headers: {
                    'Accept': '*/*',
                    "Content-Type": "application/json; charset=utf-8",
                    "X-Requested-With": "XMLHttpRequest"
                }
            })
    }

    static getSliderBannerHome = (params) => {
        return defaultRestApi.post(APIs.getSliderBannerHomeURL(params), {
            headers: {
                "Content-Type": "application/json"
            }
        })
    }

    static getMiniBanners = (params) => {
        return defaultRestApi.post(APIs.getAllMiniBannerURL(params), {
            headers: {
                "Content-Type": "application/json"
            }
        })
    }

    static getBanks = (countryCode) => {
        return defaultRestApi.post(APIs.memberGetBanks(),
            querystring.stringify({
                countryCode: countryCode
            }), {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
                }
            });
    }

    static getWallets = () => {
        return defaultRestApi.get(APIs.memberGetWallets(),
            null, {
                headers: {
                    "Content-Type": "application/json"
                }
            });
    }

    static getAllActivePayments = () => {
        return defaultRestApi.get(APIs.memberGetActivePayments(), {
            headers: {
                "Content-Type": "application/json"
            }
        })
    }

    static getSupportedPaymentTypes = (bankId, txnType) => {
        return defaultRestApi.post(APIs.memberGetSupportedPaymentTypes(),
            JSON.stringify({
                bankId: bankId,
                txnType: txnType
            }), {
                headers: {
                    'Accept': '*/*',
                    "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
                    "X-Requested-With": "XMLHttpRequest"
                }
            }
        )
    }

    static getPinPayPaymentMethods = (data) => {
        return defaultRestApi.post(APIs.memberGetPinPayPaymentMethods(),
            querystring.stringify({
                tnxType: data.tnxType,
                platform: data.platform
            }), {
                headers: {
                    'Accept': '*/*',
                    "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
                    "X-Requested-With": "XMLHttpRequest"
                }
            }
        )
    }

    static getPinPaySupportedBanks = (data) => {
        return defaultRestApi.post(APIs.memberGetPinPaySupportedBanks(),
            querystring.stringify({
                tnxType: data.tnxType,
                platform: data.platform
            }), {
                headers: {
                    'Accept': '*/*',
                    "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
                    "X-Requested-With": "XMLHttpRequest"
                }
            }
        )
    }

    static addBankingAccountService = (data) => {
        return defaultRestApi.post(APIs.memberAddBankingAccount(),
            JSON.stringify({
                country: data.country,
                bankId: data.bankId,
                bankName: data.bankName,
                bankAccName: data.bankAccName,
                bankAccNo: data.bankAccNo,
                captcha: data.captcha
            }), {
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "X-Requested-With": "XMLHttpRequest"
                }
            }
        )
    }

    static getCaptchaImage = (category) => {
        return defaultRestApi.get(APIs.getCaptchaImage(category),
            {
                headers: {
                    'Accept': '*/*',
                    "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
                    "X-Requested-With": "XMLHttpRequest"
                }
            }
        )
    }

    static activationLink = (data) => {
        return defaultRestApi.post(APIs.activationLink(),
            JSON.stringify(data), {
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "X-Requested-With": "XMLHttpRequest"
                }
            }
        )
    }

    /**
     * Get Accounts Balance API
     */
    static getAccountsBalanceAPI = () => {
      return defaultRestApi.get(APIs.getAccountsBalance(),
        {
          headers: {
            "Content-Type": "application/json"
          }
        })
    }

    /**
     * Get active product wallet API
     */
    static getActiveProductWalletAPI = () => {
      return defaultRestApi.get(APIs.getActiveProductWallet(),
        {
          headers: {
            "Content-Type": "application/json"
          }
        })
    }

    /**
     * Transfer Wallets API
     */
    static transferWalletsAPI = (data) => {
      return defaultRestApi.post(APIs.transferWallets(),
        querystring.stringify(data), {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            "X-Requested-With": "XMLHttpRequest"
          }
        }
      )
    }

    /**
     * Transfer ATA Wallets API
     */
    static ataTransferWalletsAPI = (data) => {
      return defaultRestApi.post(APIs.ataTransferWallets(),
        querystring.stringify(data), {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            "X-Requested-With": "XMLHttpRequest"
          }
        }
      )
    }

    /**
   * Authorize ATA Wallets API
   */
  static ataAuthorizeAPI = (data) => {
    return defaultRestApi.post(APIs.ataAuthorize(),
      querystring.stringify(data), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        "X-Requested-With": "XMLHttpRequest"
      }
    }
    )
  }

  /**
     * Get game dispatcher Url API
     */
    static getGameDispatcherUrlAPI = (parameters) => {
      return defaultRestApi.get(APIs.getGameDispatcherUrl(querystring.stringify(parameters)),
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
    }

    /**
     * Get AG game dispatcher Url API
     */
    static getAGGameDispatcherUrlAPI = (parameters) => {
      return defaultRestApi.get(APIs.getAGGameDispatcherUrl(querystring.stringify(parameters)),
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
    }

    /**
     * Get casino login status API
     */
    static getCasinoLoginStatusAPI = () => {
      return defaultRestApi.get(APIs.getCasinoLoginStatus(),
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
    }

    /**
     * Get CR855 Game Path API
     */
    static getCR855GamePathAPI = () => {
      return defaultRestApi.get(APIs.getCR855GamePath(),
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
    }

    /**
     * Check Playtech player online
     */
    static checkPlaytechPlayerOnlineAPI = () => {
      return defaultRestApi.get(APIs.checkPlaytechPlayerOnline(),
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
    }

    /**
     * Get Playtech player
     */
    static getPlaytechPlayerAPI = () => {
      return defaultRestApi.get(APIs.getPlaytechPlayer(),
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
    }

    /**
     * Get Casino Backround
     */
    static getCasinoBackgroundAPI = (parameters) => {
      return defaultRestApi.get(APIs.getCasinoBackground(querystring.stringify(parameters)),
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
    }

    /**
     * Check Affiliate Code
     */
    static checkAffiliateCode = (affiliateCode) => {
        return defaultRestApi.post(APIs.checkAffiliateCode(),
            querystring.stringify({'affiliateCode':affiliateCode}), {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                "X-Requested-With": "XMLHttpRequest"
            }
            }
        )
    }

    /**
     * Check Promo Code
     */
    static checkPromoCode = (promoCode, affiliateCode, country, currency) => {
        return defaultRestApi.post(APIs.checkPromoCode(),
            querystring.stringify({'promoCode':promoCode, 'affiliateCode':affiliateCode, 'country':country, 'currency':currency}), {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                "X-Requested-With": "XMLHttpRequest"
            }
            }
        )
    }

    /**
     *Get Casino Favourites service
     */
    static getCasinoFavouritesAPI = () => {
        return defaultRestApi.get(APIs.getCasinoFavourites(),
            {
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest"
                }
            })
    }

    /**
     * Update Casino Favourites service
     */
    static updateCasinoFavouritesAPI = (casinoFavourites) => {
        return defaultRestApi.post(APIs.updateCasinoFavourites(),
            JSON.stringify({ 'casinoFavorites': casinoFavourites }),
            {
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest"
                }
            })
    }

  static updateCloseGameCasinoAPI = (closeGame) => {
    return defaultRestApi.put(APIs.updateCloseGameCasino(),
      JSON.stringify(closeGame),
      {
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      }
    )
  }

    /**
     * Update locale
     */
    static updateLocale = (lang) => {
        return defaultRestApi.post(APIs.updateLocale(lang),
         {
             headers: {
               "Content-Type": "application/json"
             }
         }
       )
     }

    static updateDisplayMode = (displayMode) => {
        return defaultRestApi.post(APIs.updateDisplayMode(displayMode),
         {
             headers: {
               "Content-Type": "application/json"
             }
         }
       )
    }

    static updateDefaultView = (view) => {
        return defaultRestApi.post(APIs.updateDefaultView(view),
         {
             headers: {
               "Content-Type": "application/json"
             }
         }
       )
    }

    /**
     * Call fetching maintenance template API
     */
    static getMaintenanceTemplate = (maintenanceParameters) => {
      return defaultRestApi.get(APIs.getMaintenanceTemplate(),
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      );
  }

    /**
     * Call get Last message show at login API
     */
    static getLastMessShowAtLogin = (parameters) => {
        return defaultRestApi.get(APIs.getLastMessageURL(),
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8"
            }
          }
        );
    }

  /**
   * Get sport market for render the left menu
   */
    static getAsiaSportsMarkets = (country, v) => {
        return defaultRestApi.get(APIs.asiaSportsMarketURL(country, v),
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
      }
    
   /**
   * Get sport market for render the left menu
   */
  static getCompactSpecialLeagues = (country, v) => {
    return defaultRestApi.get(APIs.compactSpecialLeaguesURL(country, v),
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    )
  }

    static getVirtualSports = () => {
      return defaultRestApi.get(APIs.virtualSportURL(),
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
    }

    static getFavouriteSports = (eventsId) => {
      return defaultRestApi.get(APIs.favouriteSportURL(eventsId),
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
    }

    static getCompactFavouriteSports = (eventsId, leaguesId) => {
        return defaultRestApi.get(APIs.compactFavouriteSportURL(eventsId, leaguesId),
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
      }

    /**
   * Init gameflex lib for Iforium game open
   */
  static initGameflexExpressLibrayAPI = () => {
    return defaultRestApi.get(APIs.initGameflexExpressLibray(),
      {
        headers: {
          "Content-Type": "text/plain",
          "X-Requested-With": "XMLHttpRequest"
        }
      })
  }

 
   /**
   * Get player session for Golden Race VS game open
   */
  static getPlayerSessionVsAPI = (gameId) => {
    return defaultRestApi.get(APIs.getPlayerSessionVs() + "/" + gameId,
      {
        headers: {
          "Content-Type": "text/plain",
          "X-Requested-With": "XMLHttpRequest"
        }
      })
  }

   /**
   * Get Default gameId Golden Race
   */
  static getDefaultGameIdGRVsAPI = (channelId) => {
      return defaultRestApi.get(APIs.getDefaultGameIdGRVs(querystring.stringify({channelId: channelId})),
      {
        headers: {
          "Content-Type": "application/json; charset=UTF-8"
        }
      })
  }

  static changePassword = (data) => {
    const trustCodeStore = localStorage.getItem("trustCode");
    const trustCodeCookie = cookie.load('trustCode') || '';
    const trustCodeObj = JSON.parse(trustCodeStore);
    const trustCodeHeader = trustCodeObj && !isNil(trustCodeObj[data.loginId]) ? trustCodeObj[data.loginId] : ''
    return defaultRestApi.post(APIs.changePassword(),
        querystring.stringify({
          oldPassword: data.oldPassword,
          newPassword: data.newPassword,
          confirmPassword: data.confirmPassword,
          securityQns: data.securityQns,
          securityAns: data.securityAns
        }), {
          headers: {
              'Accept': '*/*',
              "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
        "X-Requested-With": "XMLHttpRequest",
        "Trust-Code": trustCodeHeader || trustCodeCookie
          }
        }
    )
  }  
  static getAllAnnouncements = (params) => {
    return defaultRestApi.get(APIs.getAllAnnouncements(stringify(params, {arrayFormat: 'comma'})));
  }

  static getMaintenanceAnnouncements = (params) => {
    return defaultRestApi.get(APIs.getMaintenanceAnnouncements(querystring.stringify(params)));
  }

  static getLeagueTranslationByLang = (params) => {
    return defaultRestApi.post(APIs.getLeagueTranslationByLang(),
    params,
    {
        headers: {
            "Content-Type": "application/json;charset=UTF-8"
        }
    })
}

  static getMessages = (params) => {
    return defaultRestApi.get(APIs.getMessages(querystring.stringify(params)));
  }

  static getUnhiddenMessagesList = (params) => {
    return defaultRestApi.get(APIs.getUnhiddenMessagesList(querystring.stringify(params)));
  }

  static getInboxMessageList = (params) => {
    return defaultRestApi.get(APIs.getInboxMessageList(querystring.stringify(params)));
  }

  static deleteMessage = (announcements) => {
    const data = {announcements: JSON.stringify(announcements)};
    return defaultRestApi.post(APIs.deleteMessage, querystring.stringify(data));
  }

  static undoMessage = (announcements) => {
    const data = {announcements: JSON.stringify(announcements)};
    return defaultRestApi.post(APIs.undoMessage, querystring.stringify(data));
  }

  static deleteAnnouncement = (announcements) => {
    const data = {announcements: JSON.stringify(announcements)};
    return defaultRestApi.post(APIs.deleteAnnouncement, querystring.stringify(data));
  }

  static undoAnnouncement = (announcements) => {
    const data = {announcements: JSON.stringify(announcements)};
    return defaultRestApi.post(APIs.undoAnnouncement, querystring.stringify(data));
  }

  static updateMessageToRead = (messageId) => {
    const data = {messageId};
    return defaultRestApi.post(APIs.updateMessageToRead(), querystring.stringify(data));
  }

  static updateAnnouncementToRead = (messageId) => {
    const data = {messageId};
    return defaultRestApi.post(APIs.updateAnnouncementToRead(), querystring.stringify(data));
  }

  static loadSelfExclusion = () => {
    return defaultRestApi.get(APIs.submitSelfExclusion());
  }

  static submitSelfExclusion = (days) => {
    const data = {days};
    return defaultRestApi.post(APIs.submitSelfExclusion(), querystring.stringify(data));
  }

  static loadBettingBudget = () => {
    return defaultRestApi.get(APIs.submitBettingBudgets());
  }

  static saveBettingBudgets = (bettingBudget, enableBettingBudget) => {
    const data = {bettingBudget: parseInt(bettingBudget, 10), enableBettingBudget};
    return defaultRestApi.post(APIs.submitBettingBudgets(), data);
  }
  static updateProfile = (profile) => {
    return defaultRestApi.post(APIs.updateProfile(),
    JSON.stringify(profile),
    {
        headers: {
            "Content-Type": "application/json;charset=UTF-8"
        }
    })
}
  static loadProfile = () => {
    return defaultRestApi.get(APIs.loadProfile(), {
      headers: {
          "Content-Type": "application/json"
      }
    });
  }

  static getStatement = (params) => {
    return defaultRestApi.get(APIs.getStatement(querystring.stringify(params))).catch(err => {
    });
  }

  static getTransactions = (data) => {
    return defaultRestApi.post(APIs.getTransactions(),
      querystring.stringify(data),
      {
        headers: {
          'Accept': '*/*',
          "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
          "X-Requested-With": "XMLHttpRequest"
        }
      })
  }

  static getProductFilter = () => {
    return defaultRestApi.get(APIs.getProductFilterURL(),
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    )
  }
  
  static getSportsLeaguesFilter = (params) => {
    return defaultRestApi.get(APIs.getSportsLeaguesFilter(querystring.stringify(params))).catch(err => {
    });
  }
  
  static getDetailWager = (params) => {
    return defaultRestApi.get(APIs.wagerDetailURL(querystring.stringify(params))).catch(err => {
    });
  }

  static getDetailTransaction = (params) => {
    return defaultRestApi.get(APIs.transactionDetailURL(querystring.stringify(params))).catch(err => {
    });
  }

  static updatePassword = (data) => {
    return defaultRestApi.post(APIs.updatePassword(),
    querystring.stringify(data), 
    {
      headers: {
        'Accept': '*/*',
        "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
        "X-Requested-With": "XMLHttpRequest"
      }
    })
  } 
  static loadSecurityQuestion = () => {
    return defaultRestApi.get(APIs.loadSecurityQuestion(), {
      headers: {
          "Content-Type": "application/json"
      }
    });
  }
  static updateSecurityQuestionAnswer = (data) => {
    return defaultRestApi.post(APIs.updateSecurityQuestionAnswer(),
    JSON.stringify(data),
    {
        headers: {
            "Content-Type": "application/json;charset=UTF-8"
        }
    })
  }
  static checkCurrentPassword = (data) => {
    return defaultRestApi.post(APIs.checkCurrentPassword(),
    querystring.stringify(data), 
    {
        headers: {
          'Accept': '*/*',
          "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
          "X-Requested-With": "XMLHttpRequest"
        }
    })
  }
  static getAccountLoginHistory = () => {
    return defaultRestApi.get(APIs.getAccountLoginHistory(), {
      headers: {
          "Content-Type": "application/json"
      }
    });
  }
    static getGenerateCashierURL = (params) => {
        return defaultRestApi.get(APIs.getGenerateCashierURL(querystring.stringify(params)), {
            headers: {
                'Accept': '*/*',
                "Content-Type": "text/plain",
                "X-Requested-With": "XMLHttpRequest"
            }
        });
    };
  static getMyBonus = (params) => {
    return defaultRestApi.get(APIs.getMyBonus(params)).catch(err => {
    });
  };
  static getTermAndCondition = (params) => {
    return defaultRestApi.get(APIs.getTermAndCondition(params)).catch(err => {
    });
  }
  
  

  static getActiveLink = (params) => {
    return defaultRestApi.get(APIs.getActiveLink(querystring.stringify(params)), {
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    }).catch(err => {});
  }

  static getRacebookAuth = (params) => {
    return defaultRestApi.get(APIs.getRacebookAuth(), {
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    });
  }

  static getRacebookIframeUrl = (params) => {
    return defaultRestApi.get(APIs.getRacebookIframeUrl(querystring.stringify(params)), {
      headers: {
        "Content-Type": "application/json"
      }
    });
  }
  static getDigitalSportsTechIntegrationIframeUrl = (params) => {
    return defaultRestApi.get(APIs.getDigitalSportsTechIntegrationIframeUrl(querystring.stringify(params)), {
      headers: {
        "Content-Type": "application/json"
      }
    });
  }
  static updateFingerPrintId = (params) => {
    defaultRestApi.post(APIs.updateFingerPrintId(querystring.stringify(params)), {
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    });
  }

  static getSportsbookFavoriteByUserId = () => {
    return defaultRestApi.get(APIs.getSportsbookFavoriteByUserId(), {
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    });
  }

  static updateSportsbookFavoriteByUserId = (favouriteData) => {
    return defaultRestApi.post(APIs.updateSportsbookFavoriteByUserId(),
      JSON.stringify(favouriteData),
      {
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    });
  }

  static getSportPeriodDesc = () => {
    return defaultRestApi.get(APIs.getSportPeriodDesc(), {
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    });
  }
  
  static getParticipantByCampaignId = (campaignId) => {
    return defaultRestApi.get(APIs.getParticipantByCampaignId(campaignId), {
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    });
  }

  static getBoardsByCampaignId = (campaignId) => {
    return defaultRestApi.get(APIs.getBoardsByCampaignId(campaignId), {
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    });
  }

  static getScoresByCampaignId = (campaignId) => {
    return defaultRestApi.get(APIs.getScoresByCampaignId(campaignId), {
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    });
  }

  static registerParticipantByCampaignId = (campaignId) => {
    return defaultRestApi.post(APIs.registerParticipantByCampaignId(),
      {
        campaignId: campaignId,
      }, { 
        headers: {
          "Content-Type": "application/json; charset=utf8"
        }
      }
    )  
  }

  /**
  * Call fetching Prestige Club API
  */
  static getPrestigeClub = (params) => {
    return defaultRestApi.post(APIs.getPrestigeClubURL(querystring.stringify(params)),
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        }
      });
  }

  /**
  * Call fetching login message API
  */
  static getLoginMessage = () => {
    return defaultRestApi.get(APIs.getLoginMessage(),
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        }
      });
  }

  /**
  * Call fetching login message API
  */
  static readLoginMessage = () => {
    return defaultRestApi.post(APIs.readLoginMessage(),
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        }
      }
    );
  }

  /**
   * Call to get mfa setting info 
   */
  static getMfaSettingInfo = () => {
    return defaultRestApi.get(APIs.getMfaSettingInfo(),
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        }
      }
    );
  }

  /**
   * Call to set mfa method type
   */
  static setMfaMethodType = (params) => {
    return defaultRestApi.post(APIs.setMfaMethodType(querystring.stringify(params)),
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        }
      }
    );
  }

  /**
   * Call to get QR code MFA
   */
  static getQRCode = () => {
    return defaultRestApi.get(APIs.getQRCode(),
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        }
      }
    );
  }

  /**
   * Call to get secretKey MFA
   */
  static getSecretKey = () => {
    return defaultRestApi.get(APIs.getSecretKey(),
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        }
      }
    );
  }
  /**
   * Call to save Qr otp 
   */
  static saveQrOtp = (params) => {
    return defaultRestApi.post(APIs.saveQrOtp(querystring.stringify(params)),
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        }
      }
    );
  }

  static getDGGameDispatcherUrl = (params) => {
    return defaultRestApi.get(APIs.getDGGameDispatcherUrl(querystring.stringify(params)),
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        }
      });
  }

  static updateReasonDPFailed = (params) => {
    return defaultRestApi.get(APIs.getUpdateReasonDpFailedURL(querystring.stringify(params)),
    {
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      }
    })
  }

  static pingToDPIframe = (params) => {
    return defaultRestApi.head(APIs.getDPIframeURL(querystring.stringify(params)));
  }

  static getDefaultSportPeriodDesc = (params) => {
    return axios.get(APIs.getSportPeriodDesc(), {
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      baseURL: defautRequestConfig.baseURL,
      params
    });
  }
  
  static getEGGameDispatcherUrl = (params) => {
    return defaultRestApi.get(APIs.getEGGameDispatcherUrl(querystring.stringify(params)),
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        }
      });
  }
}


// WEBPACK FOOTER //
// ./src/app/services/MemberService.js